export enum TenantAuthorization {
  Edit = 'EDIT',
  View = 'VIEW',
  None = 'NONE',
}
